import { useHeaderMenuContext } from '@/creditflowresearch/application/HeaderMenu/HeaderMenuContext';
import { useArticlesThemesContext } from '@/creditflowresearch/application/ArticlesAndStats/ArticlesMarketThemesContext';
import { getProductsFromThemeIds } from '@/creditflowresearch/ui/components/creditFlow/articles/helpers';

const ProductsCell = ({ row }) => {
  const { products: productsList } = useHeaderMenuContext();
  const { themes, isInitialized: isThemesInitialized } = useArticlesThemesContext();

  if (!isThemesInitialized) {
    return '-';
  }

  const products = getProductsFromThemeIds(themes, row.themes, productsList);

  if (!products.length) {
    return '-';
  }

  return products.map((product) => product.abbreviation).join(', ');
};

export default ProductsCell;
